import { useState } from "react";
import { useLocation } from "react-router-dom";

import { Route } from "~services/router/Route";

export type EmploymentSurveyOutcome = "hired" | "none-hired" | "not-hired";

export interface EmploymentSurveyAccess {
  outcome?: EmploymentSurveyOutcome;
  token?: string;
}

const employmentSurveyPaths = new Set([Route.candidateAttestation(), Route.orgCandidates()]);

export function parseEmploymentSurveyAccess(hash: string): EmploymentSurveyAccess {
  const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const token = params.get("token")?.trim() || undefined;
  const rawOutcome = params.get("outcome");
  const outcome =
    rawOutcome === "hired" || rawOutcome === "none-hired" || rawOutcome === "not-hired" ? rawOutcome : undefined;

  return { outcome, token };
}

export function useEmploymentSurveyAccess(): EmploymentSurveyAccess {
  const { hash } = useLocation();
  const [access] = useState(() => {
    const parsed = parseEmploymentSurveyAccess(hash);
    if (parsed.token) {
      window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}`);
    }
    return parsed;
  });

  return access;
}

export function useIsTokenizedEmploymentSurveyRoute(): boolean {
  const { hash, pathname } = useLocation();
  const [tokenizedPath] = useState(() =>
    employmentSurveyPaths.has(pathname) && parseEmploymentSurveyAccess(hash).token ? pathname : undefined,
  );

  return tokenizedPath === pathname;
}
